export default {"src":"/_next/static/media/blue-value.10b2a10b.svg","height":25,"width":112,"blurWidth":0,"blurHeight":0};